export default "__VITE_ASSET__CZNbvrek__"